import PincodeInput from 'react-pinco';
import { ReactPincoCustom } from './styled';

type Props = {
  onChange: (value: string) => void;
};
const TextfieldOneTimePassword = ({ onChange }: Props) => (
  <ReactPincoCustom>
    <PincodeInput
      onChange={(value: []) => {
        onChange(value.join(''));
      }}
      numInputs={6}
      containerStyle="Pincode-container"
      inputStyle="Pincode-input"
      errorStyle="Pincode-error"
      isInputNum={true}
      shouldAutoFocus={true}
      sx={{ borderRadius: 0 }}
    />
  </ReactPincoCustom>
);

export default TextfieldOneTimePassword;
